var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02083 6.49583C4.22083 8.85417 6.15 10.7833 8.5125 11.9833L10.3458 10.1458C10.575 9.91667 10.9042 9.85 11.1917 9.94167C12.125 10.25 13.1292 10.4167 14.1667 10.4167C14.6292 10.4167 15 10.7875 15 11.25V14.1667C15 14.6292 14.6292 15 14.1667 15C6.34167 15 0 8.65833 0 0.833333C0 0.370833 0.375 0 0.833333 0H3.75C4.2125 0 4.58333 0.370833 4.58333 0.833333C4.58333 1.87083 4.75 2.875 5.05833 3.80833C5.15 4.09583 5.08333 4.425 4.85417 4.65417L3.02083 6.49583Z",
    fill: "#C1C5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.790a649e.svg";
export { ForwardRef as ReactComponent };